import { Validator, AbstractControl, ValidationErrors } from '@angular/forms';
var EqualValidatorDirective = /** @class */ (function () {
    function EqualValidatorDirective(validateEqual, reverse) {
        this.validateEqual = validateEqual;
        this.reverse = reverse;
    }
    EqualValidatorDirective.prototype.validate = function (control) {
        var target = control.root.get(this.validateEqual);
        if (!target) {
            return null;
        }
        var errors = target.value === control.value
            ? null
            : { validateEqual: true };
        if (this._isReverse) {
            target.setErrors(errors);
            return null;
        }
        return errors;
    };
    Object.defineProperty(EqualValidatorDirective.prototype, "_isReverse", {
        get: function () {
            return this.reverse === 'true';
        },
        enumerable: true,
        configurable: true
    });
    return EqualValidatorDirective;
}());
export { EqualValidatorDirective };
